<template>
  <content-area :items="items" />
</template>

<script>
import ContentArea from '@/components/ContentArea.vue'
import HelperMixin from '@/mixins/helper'

export default {
  mixins: [HelperMixin],
  components: {
    ContentArea
  },
  computed: {
    info () {
      return this.$store.getters['hsm/GET_INFO']
    },
    battery_status: function () {
      return this.info.battery_ok === 1 ? this.$t('ok') : this.$t('low')
    },
    warnings () {
      const wngArray = this.$store.getters['warning/getWarnings']
      wngArray.sort((a, b) => (a.type > b.type) ? -1 : 1)
      return wngArray
    },
    fips_str: function () {
      let mode
      const modeData = this.$store.state.hsm.statInfo.hsm_mode
      if (modeData === 0) mode = 'NRM'
      else if (modeData === 1) mode = 'RM1'
      else if (modeData === 2) mode = 'RM2'
      else mode = 'unknown'
      return mode
    },
    logstate: function () {
      if (this.info.state === 11) {
        return this.$t('enabled')
      } else {
        return this.$t('disabled')
      }
    },
    logSize () {
      return this.$store.state.hsm.logSize
    },
    items () {
      const info = this.info
      let warnings = this.warnings.map(el => { return this.prettyTitle(el) }).toString().replace(',', ', ')
      if (warnings.length === 0) {
        warnings = this.$tc('none', 2)
      }

      if (info) {
        const items = [
          {
            title: this.$tc('now'),
            data: `${this.$getDateString({ date: info.current_dt_info })} GMT-3`,
            testId: 'now'
          },
          {
            title: this.$tc('uptime'),
            data: this.getElapsedTimeString({ secondsInterval: (info.uptime) }),
            testId: 'uptime'
          },
          {
            title: this.$tc('battery'),
            data: this.battery_status,
            testId: 'battery'
          },
          {
            title: this.$tc('operation_mode'),
            data: this.fips_str,
            testId: 'operation_mode'
          },
          {
            title: this.$tc('storage'),
            data: `${Math.floor(
              (1 - info.free_blocks / info.total_blocks) * 100
            )}%`,
            testId: 'storage'
          },
          {
            title: this.$tc('log_size'),
            data: `${this.logSize} bytes (${this.$options.filters.prettyBytes(
              this.logSize
            )})`,
            testId: 'log_size'
          },
          {
            title: this.$tc('log_status'),
            data: this.logstate,
            testId: 'log_status'
          },
          {
            title: this.$tc('db_size'),
            data: `${this.$options.filters.prettyBytes(info.sl_be_len)}`,
            testId: 'db_size'
          },
          {
            title: this.$tc('total_users'),
            data: info.usr_count,
            testId: 'total_users'
          },
          {
            title: this.$tc('total_objects'),
            data: info.obj_count,
            testId: 'total_objects'
          },
          {
            title: this.$tc('session', info.session),
            data: info.session,
            testId: 'session'
          },
          {
            title: this.$tc('cpu'),
            data: `${info.cpu}%`,
            testId: 'cpu'
          },
          {
            title: this.$tc('memory'),
            data: `${info.mem_used}%`,
            testId: 'memory'
          },
          {
            title: this.$tc('tampered'),
            data: info.tampered_hsm ? this.$t('yes') : this.$t('no'),
            testId: 'tampered'
          },
          {
            title: this.$tc('remoot'),
            data: info.remoot ? this.$t('yes') : this.$t('no'),
            testId: 'remoot'
          },
          {
            title: this.$tc('warning', 2),
            data: `<div>${warnings}</div>`,
            html: true,
            testId: 'warning'
          }
        ]
        if (info.ds_bound) {
          items.push(
            {
              title: this.$tc('ds_hsm'),
              data: info.ds_hsm,
              testId: 'ds_hsm'
            },
            {
              title: this.$tc('ds_account'),
              data: info.ds_account,
              testId: 'ds_account'
            },
            {
              title: this.$tc('ds_url'),
              data: info.ds_url,
              testId: 'ds_url'
            }
          )
        } else {
          items.push(
            {
              title: this.$tc('bind_dinamo_services'),
              data: info.ds_bound ? this.$t('yes') : this.$t('no'),
              testId: 'ds_bound'
            }
          )
        }
        return items
      }
      return []
    }
  },
  methods: {
    prettyTitle (warning) {
      switch (warning.title) {
        case 'pending_upack': return this.$tc('warnings.pending_upack')
        case 'pending_backup': return this.$tc('warnings.pending_backup')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  background-color: transparent;
}
</style>
